import { GetSettingsResult, SaveSettingsResult, Settings } from '@anispi-reporting-system/types';
import { API_URL } from './settings';

const getSettings = async (): Promise<GetSettingsResult> => {
  const url = `${API_URL}/getSettings`;

  const response = await fetch(url, {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    mode: 'cors',
  });

  const result = (await response.json()) as GetSettingsResult;

  if (!response.ok) {
    result.success = false;
  }

  return result;
};

interface SaveSettingsProps {
  settings: Settings;
}

const saveSettings = async (props: SaveSettingsProps): Promise<SaveSettingsResult> => {
  const url = `${API_URL}/saveSettings`;

  const response = await fetch(url, {
    body: JSON.stringify(props),
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    mode: 'cors',
  });

  const result = (await response.json()) as SaveSettingsResult;

  if (!response.ok) {
    result.success = false;
  }

  return result;
};

export { getSettings, saveSettings };
